import BaseController from "controllers/pages/base";

class Controller extends BaseController {
  call() {
    super.call();

    console.log("Enq Controller")

    if ($('.has-error').length) {
      $('html, body').animate({
          scrollTop: ($('.has-error').first().offset().top - $('.navbar').height())
      },500);
    }
  }
};


export default Controller;
